var App = App || {};

App.VideoCarousel = (function ($) {
    'use strict';

    function Init(widget) {

        const carousel = widget.find(".splide");

        if (!carousel.length)
            return false;

        Carousel(carousel);
    }

    function Carousel(carousel) {

        var splide = new Splide(carousel[0], {
            type: "loop",
            focus: "center",
            pagination: false,
            perPage: 3,
            fixedWidth: "33%",
            width: "80%",
            arrows:true,
            breakpoints: {
                991: {
                    perPage: 1,
                    fixedWidth: "100%",
                },
            }
        });

        splide.on('mounted', function () {
            $(window).on("resize", function () { });
        });

        splide.on('move', function (newIndex, prevIndex) {
            const slideNew = $(splide.Components.Slides.getAt(newIndex).slide);
            const slideOld = $(splide.Components.Slides.getAt(prevIndex).slide);

            slideNew.addClass("is-active");
            slideOld.removeClass("is-active");
        });

        splide.mount({});

    }

    return {
        Init: Init
    };

})(jQuery);